import React from "react";
import Top_bar from "../../Components/topBar/topBar";
import "./prelude.css";
import { Tab, Row, Col, ListGroup } from "react-bootstrap";
import AddOrder from "../Registration/Order/addOrder";
import AltOrder from "../Registration/Order/altOrder";
import DelOrder from "../Registration/Order/delOrder";
import BottomBar from "../../Components/bottomBar/bottomBar";
import {handleColor} from '../../services/Functions';
import ReportOrders from "../Reports/reportOrders";
class prelude_ordens extends React.Component {
  render() {
    return (
      <>
        <Top_bar title="Cadastro ordem de produção" />
        <div className="prelude_container">
          <Sidebar></Sidebar>
        </div>
        <BottomBar></BottomBar>
      </>
    );
  }
}

class Sidebar extends React.Component {
  state = { click: false };
  handleClick = () => {
    if (this.props.click === false) {
      this.setState({ click: true });
      return true;
    } else {
      this.setState({ click: false });
      return false;
    }
  };

  

  render() {
    return (
      <Tab.Container defaultActiveKey="list">
        <Row  style={{width:'100%',height:'100%'}}>
        <div className="sidebar1">
            <div className="sidebar2">
              <Col className="sidebarColumn">
                <ListGroup>
                <ListGroup.Item
                    mountOnEnter
                    unmountOnExit
                    id="lg4"
                    onClick={handleColor}
                    style={{
                      backgroundColor: "#05ca83",
                      color: "#fff",
                      border: "none",
                    }}
                    className="listGroup"
                    action
                    eventKey="list"
                  >
                    Histórico de Ordens
                  </ListGroup.Item>
                  <ListGroup.Item
                    mountOnEnter
                    unmountOnExit
                    id="lg1"
                    onClick={handleColor}
                    className="listGroup"
                    action
                    eventKey="add-order"
                  >
                    Nova ordem
                  </ListGroup.Item>
                  <ListGroup.Item
                    mountOnEnter
                    unmountOnExit
                    id="lg2"
                    onClick={handleColor}
                    className="listGroup"
                    action
                    eventKey="alt-order"
                  >
                    Alterar Ordem
                  </ListGroup.Item>
                  <ListGroup.Item
                    mountOnEnter
                    unmountOnExit
                    id="lg3"
                    onClick={handleColor}
                    className="listGroup"
                    action
                    eventKey="del-order"
                  >
                    Deletar Ordem
                  </ListGroup.Item>
                </ListGroup>
              </Col>
            </div>
            <Col className='col3' style={{ top: "2%", marginLeft: "1%", width: "100%",height:'96%'}}>
              <Tab.Content style={{height:'100%'}}>
              <Tab.Pane style={{display:'flex',flexDirection:'row',justifyContent:'center'}} mountOnEnter unmountOnExit eventKey="list">
                  {this.handleClick ? <ReportOrders /> : null}
                </Tab.Pane>
                <Tab.Pane style={{display:'flex',flexDirection:'row',justifyContent:'center'}} mountOnEnter unmountOnExit eventKey="add-order">
                  {this.handleClick ? <AddOrder /> : null}
                </Tab.Pane>
                <Tab.Pane style={{display:'flex',flexDirection:'row',justifyContent:'center',overflow: "scroll", overflowX: "hidden"}} mountOnEnter unmountOnExit eventKey="alt-order">
                  {this.handleClick ? <AltOrder /> : null}
                </Tab.Pane>
                <Tab.Pane style={{display:'flex',flexDirection:'row',justifyContent:'center'}} mountOnEnter unmountOnExit eventKey="del-order">
                  {this.handleClick ? <DelOrder /> : null}
                </Tab.Pane>
              </Tab.Content>
            </Col>
          </div>
        </Row>
      </Tab.Container>
    );
  }
}

export default prelude_ordens;